import { z } from 'zod'

/** Visible posture of a screen cell (role × state). */
export const POSTURES = [
  'denied',
  'loading',
  'empty',
  'error',
  'ready',
  'partial',
] as const

export type Posture = (typeof POSTURES)[number]

export const PostureSchema = z.enum(POSTURES)
